export const GET_ALL_PAYROLL = "GET_ALL_PAYROLL";
export const GET_ALL_PAYROLL_START = "GET_ALL_PAYROLL_START";
export const GET_ALL_PAYROLL_FAILED = "GET_ALL_PAYROLL_FAILED";

export const DOWNLOAD_GET_ALL_PAYROLL = "DOWNLOAD_GET_ALL_PAYROLL";
export const DOWNLOAD_GET_ALL_PAYROLL_START = "DOWNLOAD_GET_ALL_PAYROLL_START";
export const DOWNLOAD_GET_ALL_PAYROLL_FAILED = "DOWNLOAD_GET_ALL_PAYROLL_FAILED";
